import { viewer } from "src/main";
import { SelectedLayerState, TopLevelLayerListSpecification } from "../layer";
import { animationFrameDebounce } from "../util/animation_frame_debounce";
import { Borrowed } from "../util/disposable";
import { removeFromParent } from "../util/dom";
import { responseJson } from "../util/http_request";
import { emptyToUndefined } from "../util/json";
import { NullarySignal } from "../util/signal";
import { cancellableFetchSpecialOk } from "../util/special_protocol_request";
import { DropLayers, registerLayerBarDragLeaveHandler, registerLayerBarDropHandlers } from "./layer_drag_and_drop";
import { makeElement } from "./layer_gene_table_tab";
import { SidePanel, SidePanelManager } from "./side_panel";
import { DEFAULT_SIDE_PANEL_LOCATION, SidePanelLocation, TrackableSidePanelLocation } from "./side_panel_location";

const DEFAULT_PROTEIN_PANEL_LOCATION: SidePanelLocation = {
    ...DEFAULT_SIDE_PANEL_LOCATION,
    side: 'right',
    row: 0,
};
export class proteinPanelState{
  location = new TrackableSidePanelLocation(DEFAULT_PROTEIN_PANEL_LOCATION);
  layerManager: { managedLayers: any; };JSON() {
    return emptyToUndefined(this.location.toJSON());
  }
  get changed() {
      return this.location.changed;
  }
  toJSON() {
      return emptyToUndefined(this.location.toJSON());
  }
  get visible(){
      // console.log(this.location.watchableVisible.value)
      return this.layerManager;
  }
  reset() {
    this.location.reset();
  }
  restoreState(obj: unknown) {
    this.location.restoreState(obj);
  }
}

const allUserLayer:any = [];
let lastBin:any = '';


export class proteinTabView extends SidePanel {
  element = document.createElement('div');
  tabBar = document.createElement('div');
  proteinContainer = makeElement('div', ['proteinContatiner']);
  selectBinContainer = makeElement('div', ['selectBinContainer']);
  selectElement = document.createElement('select');
  proteinName = makeElement('div', ['protein-name']);
  proteinControl = makeElement('div', ['protein-control']);
  changed = new NullarySignal();
  dropLayers: DropLayers|undefined;
  dragEnterCount = 0;
  get layerManager() {
    return this.manager.layerManager;
  }

  constructor(
    public sidePanelManager: SidePanelManager, 
    public state: proteinPanelState, 
    public manager: Borrowed<TopLevelLayerListSpecification>,
    public selectedLayer: Borrowed<SelectedLayerState>) {

    super(sidePanelManager, state.location);
    const { selectBinContainer, proteinContainer, element, tabBar } = this;
    element.classList.add('neuroglancer-annotation-protein-tab', 'neuroglancer-side-panel');
    this.addTitleBar({title: 'Protein Control Panel'});
    element.appendChild(tabBar);
    proteinContainer.style.overflowY = 'auto'
    proteinContainer.style.padding = '2px 20px';
    selectBinContainer.style.display = 'flex';
    const debouncedUpdateView =
    this.registerCancellable(animationFrameDebounce(() => this.render()));
    this.visibility.changed.add(debouncedUpdateView);
    this.registerDisposer(this.layerManager.layersChanged.add(debouncedUpdateView));
    registerLayerBarDragLeaveHandler(this);
    registerLayerBarDropHandlers(this, element, undefined, /*allowArchived=*/ true);
    this.render();
  }

  render(){
    this.layerManager.updateNonArchivedLayerIndices();
    this.selectBinContainer.innerHTML = '';
    this.proteinContainer.innerHTML = '';
    this.proteinContainer.appendChild(this.getElectModel());
    this.proteinContainer.appendChild(this.getProteinName(this.manager.layerManager));
    this.element.appendChild(this.proteinContainer); 
  }

  getElectModel(){
    const {selectElement, selectBinContainer} = this;
    selectElement.innerHTML = '';
    let label = makeElement('label', ['selectBinLabel'], {}, `Please select model：`);
    selectElement.classList.add('neuroglancer-layer-side-panel-type-protein-select');
    selectElement.id = 'proteinSelectBin';
    const binList = viewer.dataSource.subsources[0].subsource.annotation?.metadata?.binlist;
    this.registerDisposer(() => removeFromParent(selectBinContainer));
    let json = viewer.state.toJSON();
    let layers = json.layers;
    if(layers?.length > 1){
      // 获取任意蛋白层的binsize（每层都一样）即可
      for (let item of layers){
        if(item.genetype == 'proteinimage'){
          lastBin = item.source.split('/');
          lastBin = lastBin[lastBin.length - 1];
          break;
        }
      }
      if(binList?.length>0 && lastBin.includes('bin')){
        for(let i = 0; i < binList.length; i++){
          selectElement.options.add(new Option(binList[i], binList[i],false, binList[i] === lastBin?true:false) );
        }
      }else{
        selectElement.style.display = 'none';
        label.style.display = 'none';
      }
      selectElement.onchange = ()=>{
        this.onchange();
      }
      selectBinContainer.appendChild(label);
      selectBinContainer.appendChild(selectElement);
      return selectBinContainer;
    }
    return selectBinContainer;
  }
  async onchange(){
    let objS = this.selectElement.value;
    let _json = viewer.state.toJSON();
    let _newlayers = _json.layers;
    let _source = '';
    let maxvalue:any = null;
    for(let i = 0; i < _newlayers.length; i++){
      if(_newlayers[i].genetype === 'proteinimage'){
        if(!_newlayers[i].name.includes('ssDNA') && !_newlayers[i].name.includes('IF')){
          _newlayers[i].source = _newlayers[i].source.replace(lastBin, objS);
          if(!maxvalue){
            _source = _newlayers[i].source.replace('precomputed://','');
            let res = await getMaxRange(_source);
            if(res.code === 0){
              maxvalue = res.data
            }
          }
          _newlayers[i].shaderControls.normalized.range[1] = maxvalue.maxValue;
          _newlayers[i].shaderControls.normalized.window[1] = maxvalue.maxValue;
        }
      }
    }
    _json.layers = _newlayers;
    viewer.state.restoreState(_json);
  }
  getProteinName(layermanage: any){
    let ManagedUserLayer:any = layermanage.managedLayers;
    const selectOption = makeElement('div', ['selectOpt']);
    let json_ = viewer.state.toJSON();
    ManagedUserLayer.forEach((value:any, id: number)=>{
      if( !value.name_.includes('_exp') && value.genetype === 'proteinimage'){
        allUserLayer.push(value);  // 存储所有的layers
        var radio = makeElement('input', [],{'style': 'width: 14px;height:14px','type':'radio', 'indexnumber': id,'name': 'proteinName', 'value': value.name_}) as HTMLInputElement;
        var label = makeElement('label', [], {}, value.name_);
        var ele = makeElement('div',[],{'style': 'min-height: 1.5rem;line-height: 1.5rem;'});
        if(value.name_ === json_?.selectedLayer?.layer){
          radio.setAttribute('checked','checked');
        }
        ele.appendChild(radio);
        ele.appendChild(label);
        selectOption.appendChild(ele);
        radio.addEventListener('change',()=>{
          let _json = viewer.state.toJSON();
          _json.selectedLayer = {
            "layer": value.name,
            "visible": true
          }
          viewer.state.restoreState(_json);
          this.render();
        })
      }
    })
    return selectOption
  }
}
async function getMaxRange(url:any){
  let req = async (): Promise<any> =>{
      return await cancellableFetchSpecialOk(undefined, `${url}/maxValue`, {}, responseJson);
  };
  return await req();
}